import { render, staticRenderFns } from "./ModalKota.vue?vue&type=template&id=4f1c7431&scoped=true"
import script from "./ModalKota.vue?vue&type=script&lang=js"
export * from "./ModalKota.vue?vue&type=script&lang=js"
import style0 from "./ModalKota.vue?vue&type=style&index=0&id=4f1c7431&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1c7431",
  null
  
)

export default component.exports